<script setup lang="ts">
import {defineProps} from "vue"
import EventActivitiesCaroussel from "@/views/event-activities/components/EventActivitiesCaroussel.vue";

const props = defineProps({
  slideItems: {type: Array, default:()=> []
  },
});
</script>

<template>
  <div
      class="impx-slide-container hp5 uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom uk-background-fixed uk-background-center-center uk-height-1-1">
    <div class="impx-overlay dark"></div>
    <div class="uk-container uk-margin-top impx-margin-top-small">
      <event-activities-caroussel v-if="props.slideItems" :carrousel-element="props.slideItems"></event-activities-caroussel>
    </div>
  </div>
</template>

<style scoped>

</style>